module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "weui-cells weui-cells_checkbox"
  }, [_c('div', {
    staticClass: "weui-cell weui-check__label",
    class: [_vm.point ? 'weui-cell_access' : '', _vm.themeName]
  }, [_c('div', {
    staticClass: "weui-cell__hd",
    on: {
      "&click": function($event) {
        _vm.likeLabel('head')
      }
    }
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "text-elps ds-flex align-center weui-cell__bd",
    on: {
      "&click": function($event) {
        _vm.likeLabel('body')
      }
    }
  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft",
    on: {
      "&click": function($event) {
        _vm.likeLabel('foot')
      }
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempValue),
      expression: "tempValue"
    }],
    staticClass: "weui-check",
    attrs: {
      "type": "checkbox",
      "disabled": "disabled"
    },
    domProps: {
      "checked": Array.isArray(_vm.tempValue) ? _vm._i(_vm.tempValue, null) > -1 : (_vm.tempValue)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.tempValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.tempValue = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.tempValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.tempValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    class: [_vm.tempValue ? 'text-color orange s-icon-check-circle' : 'no-check']
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3baa1953","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-cell-checkbox/index.vue
// module id = 1036
// module chunks = 2